var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gc-preloader"},[_c('icon-preloader',{attrs:{"size":'lg3'}}),_c('text-body-small',[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }